import Button, { ButtonProps } from '~/components/interactive/Button';
import useLoadingClick from '~/components/hooks/useLoadingClick';
import IconSolidLoading from '~/components/icons/streamline/solid/IconSolidLoading';
import { useCallback, useEffect, useRef, useState } from 'react';
import IconCheck from '~/components/icons/streamline/line/IconCheck';

export default function LoadingButton({ variant, ...props }: ButtonProps) {
  const [loading, onClickWrapper] = useLoadingClick();
  const [isSuccess, setSuccess] = useState(false);
  const saving = useRef(false);

  useEffect(() => {
    if (loading && !saving.current) {
      saving.current = true;

      return;
    }

    if (!loading && !saving.current) {
      return;
    }

    setSuccess(true);

    const timeout = setTimeout(() => {
      saving.current = false;

      setSuccess(false);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [loading]);

  const onClick = useCallback(
    onClickWrapper((e) => {
      if (props.onClick) {
        return props.onClick(e);
      }
    }),
    [props.onClick],
  );

  return (
    <Button
      {...props}
      variant={isSuccess || saving.current ? 'success' : variant}
      onClick={onClick}
      disabled={loading ? true : props.disabled}
      icon={isSuccess ? <IconCheck /> : loading ? <IconSolidLoading /> : props.icon}
    />
  );
}
